import { useMemo } from 'react';
import { Flex, Image, useTheme, Text, Button, ThemeProvider, Link } from '@aws-amplify/ui-react';
import { I18n } from 'aws-amplify';

import Footer from 'components/Authenticator/components/Footer';
import { useLabelOptions } from 'contexts/labelOptionsContext';
import { useLocaleState } from 'contexts/localeContext';
import { getTheme } from 'theme';

import accessRestrictedImage from './images/accessRestricted.svg';

const AccessRestrictedByIpPage = () => {
  const { tokens } = useTheme();
  const { labelOptions } = useLabelOptions();
  const { rtl } = useLocaleState();
  const theme = useMemo(() => getTheme(labelOptions.brand), [labelOptions]);

  return (
    <ThemeProvider theme={theme} direction={rtl ? 'rtl' : 'ltr'}>
      <Flex direction="column" alignItems="center" height="100vh">
        <div style={{ height: 8, width: '100%', backgroundColor: theme.tokens.colors.errorDark.value }} />
        <Flex
          direction="column"
          alignItems="center"
          justifyContent="center"
          gap="0"
          padding={{ base: tokens.space.medium, medium: tokens.space.large }}
          maxWidth="100%"
          flex="1"
        >
          <Image
            alt="access restricted"
            src={accessRestrictedImage}
            marginBottom={{ base: tokens.space.medium, medium: '32px' }}
            maxWidth={{ base: '200px', medium: '100%' }}
            width="100%"
            style={{ objectFit: 'contain' }}
          />
          <Text
            color={theme.tokens.colors.error.value}
            fontSize={{ base: tokens.fontSizes.large, medium: tokens.fontSizes.xl }}
            textAlign="center"
            marginBottom={tokens.space.xs}
          >
            {I18n.get('accessRestrictedByIp.title')}
          </Text>
          <Text
            fontSize={{ base: tokens.fontSizes.small, medium: tokens.fontSizes.medium }}
            marginBottom="24px"
            textAlign="center"
            paddingLeft={tokens.space.small}
            paddingRight={tokens.space.small}
          >
            {I18n.get('accessRestrictedByIp.contactInfo.prefix')}{' '}
            <Link href={`mailto:${labelOptions.supportEmail}`}>
              {I18n.get('accessRestrictedByIp.contactInfo.support')}
            </Link>
          </Text>
          <Button variation="primary" onClick={() => {
            sessionStorage.removeItem('ipRestricted');
            window.location.href = '/';
          }}>
            {I18n.get('accessRestrictedByIp.backToLogin')}
          </Button>
        </Flex>
        <Footer />
      </Flex>
    </ThemeProvider>
  );
};

export default AccessRestrictedByIpPage;
